import { Step } from 'react-joyride';

export const dataCenterSteps: Step[] = [
  {
    target: '.tour-data-center-header',
    title: 'Data Center',
    content:
      'This is the data center, where you can see all the important information about your franchise.',
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '.tour-invite-candidate',
    title: 'Invite Candidate',
    content:
      'To invite a new candidate to join your franchise dashboard, click here.',
    placement: 'bottom',
    disableBeacon: true,
    disableOverlayClose: true,
  },
  {
    target: '.tour-leads-tab',
    title: 'Leads Tab',
    content:
      'This is the leads tab, where you can see all the prospects and leads you have invited to the platform.',
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '.tour-leads-search',
    title: 'Search Leads',
    content:
      'Use this search bar to quickly find specific leads by name, email, or inviter.',
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '.tour-leads-sort',
    title: 'Sort Leads',
    content:
      'Sort your leads by name, email, generation date, status, or who invited them.',
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '.tour-leads-table',
    title: 'Leads Table',
    content:
      'This table shows all your leads with their contact information, generation date, and current status.',
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '.tour-prospect-name',
    title: 'Prospect Information',
    content: "View the prospect's name, email, and profile photo here.",
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '.tour-lead-generated',
    title: 'Generated Date',
    content: 'This shows when the lead was first generated or invited.',
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '.tour-invited-by',
    title: 'Invited By',
    content: 'See who invited this prospect to the platform.',
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '.tour-referred-by',
    title: 'Referred By',
    content:
      "If the prospect was referred by someone, you'll see that information here.",
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '.tour-invite-status',
    title: 'Invitation Status',
    content:
      "Track the status of invitations - whether they've been sent, accepted, or referred.",
    placement: 'left',
    disableBeacon: true,
  },
];
